import { getIsInitialised } from '@wetransfer/transfer/modules/experiments';

import { isAdBlockingLibraryEnabled, getAdBlockDetection } from '.';

export const getReadyInitialState = (): boolean => {
  // if experiments are not initialized we cannot know if the ad blocking library is enabled
  if (!getIsInitialised()) {
    return false;
  }

  // if the adblocking library is not enabled, we don't need to wait for the result
  if (!isAdBlockingLibraryEnabled()) {
    return true;
  }

  return Boolean(getAdBlockDetection());
};
